// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.custom-event-card {\r\n  color: white;\r\n  font-size: 12px;\r\n  line-height: 1.5;\n}\n[dir] .custom-event-card {\r\n  padding: 10px;\r\n  border-radius: 5px;\n}\n[dir=ltr] .custom-event-card {\r\n  text-align: left;\n}\n[dir=rtl] .custom-event-card {\r\n  text-align: right;\n}\r\n", ""]);
// Exports
module.exports = exports;
